function GuestHistoryReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">GuestHistoryReport</div>
      </>
    );
  }
  
  export default GuestHistoryReport;